"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _buttonControl = _interopRequireDefault(require("../../../preact-components/button-control"));

var ActionCell = function ActionCell(openCancelInvitation) {
  return function (_ref) {
    var id = _ref.id,
        url = _ref.url,
        isInvite = _ref.isInvite;
    return (0, _preact.h)("div", {
      className: "team-overview__table-action"
    }, isInvite ? (0, _preact.h)(_buttonControl.default, {
      title: "Cancel invitation",
      variant: "warning",
      onClick: function onClick() {
        return openCancelInvitation(id);
      }
    }) : (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)(url),
      target: "_blank",
      className: "team-overview__table-action__link"
    }, (0, _preact.h)(_buttonControl.default, {
      title: "Edit role",
      variant: "secondary",
      class: "action__link"
    })));
  };
};

var _default = ActionCell;
exports.default = _default;